import React from 'react';
import NotificationTemplate from "./NotificationTemplate";
import CurrencyLabel from "../../../components/CurrencyLabel/CurrencyLabel";
import TTLProxy from "../../TTLAsyncProxy";
import {UserRoles} from "../../Constants";
import history from '../../../history';

function PaymentInfoTemplate({ payment , title, onClick }) {

    return <NotificationTemplate title={title}
                                 properties={[
                                     {
                                         title: "Amount",
                                         value: <CurrencyLabel currency={payment.currency} value={payment.amount}/>
                                     },
                                     {
                                         title: "Charges",
                                         value: <CurrencyLabel currency={payment.currency} value={payment.charges}/>
                                     },
                                     {
                                         title: "Reference",
                                         value: payment.local_reference
                                     }
                                 ]}
                                 onClick={() => {

                                     switch (TTLProxy.getInstance().getUserRole()) {
                                         case UserRoles.Owner:
                                             history.push(`/payments?filter_id=${payment.id}&q=${payment.local_reference}`);
                                             break;
                                         case UserRoles.Admin:
                                             history.push(`/finance/payouts?filter_id=${payment.id}&q=${payment.local_reference}`);
                                             break;

                                     }

                                     if(onClick){
                                         onClick();
                                     }

                                 }}/>
}

export default PaymentInfoTemplate;


// WEBPACK FOOTER //
// ./src/common/UserNotifications/PopupTemplates/PaymentInfoTemplate.js